export const NotificationMixins = {
  methods: {
    notifySuccess: function(message, options) {
      return new Promise(resolve => {
        this.$store.dispatch('notification/notifySuccess', { message, options });
        resolve();
      });
    },
    notifyFailure: function(message, options) {
      return new Promise(resolve => {
        this.$store.dispatch('notification/notifyFailure', { message, options });
        resolve();
      });
    },
  },
};
